<template>
  <div class="regulatory-footer-wrapper" :class="{'centralized' : userDevice === 'm'}">
    <div class="rule-container">
      <a v-if="$route.query.responsibleURL" href="#" @click="openLink($route.query.responsibleURL)" class="button-fa-icon">
        <font-awesome-icon icon="fa-solid fa-shield-halved" color="white" size="xl" />
      </a>
      <a v-if="rulePath" @click="openLink(rulePath)" class="button-fa-icon">
        <font-awesome-icon icon="fa-solid fa-book" color="white" size="xl" />
      </a>
    </div>
    <button v-if="userDevice === 'd'" @click="$store.dispatch('toggleFullscreen')" class="button-fa-icon">
      <font-awesome-icon :icon="icon" color="white" size="2xl" />
    </button>
  </div>
</template>

<script>
import openLink from '@/mixins/openLink';

export default {
  name: 'SKRegulatoryFooter',
  mixins: [openLink],
  props: { userDevice: { type: String, default: 'd' } },
  data: () => ({ rulePath: null }),
  computed: { icon: vm => vm.$store.getters.isFullScreen ? 'fa-solid fa-minimize' : 'fa-solid fa-maximize' },
  created () {
    const upperCaseProvider = this.$route.params.provider.toUpperCase();
    const showPDFRules = upperCaseProvider === 'EGT' || upperCaseProvider === 'BETINSIGHT';
    showPDFRules && this.setPDFPath();

    this.$store.dispatch('setFullScreenEvents');
  },
  methods: {
    setPDFPath () {
      const { gameCode, languageCode } = this.$route.query;
      const provider = this.$route.params.provider;
      const rulePath = `https://gamecontainer.ifortuna.sk/rules/${provider}/${languageCode}/${gameCode}.pdf`;
      this.rulePath = rulePath.toLowerCase();
    }
  }
}
</script>

<style lang="scss" scoped>
  .regulatory-footer-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 20px;
    height: 32px;
    background-color: #17171b;
    color: white;

    .rule-container {
      display: flex;
      gap: 16px;
    }

    .button-fa-icon {
      background-color: transparent;
      border: none;
      justify-self: end;
      cursor: pointer;
    }
  }

  .centralized {
    justify-content: center;
  }
</style>
